import { QueryConfig } from "store/utils/query-config";

export const ccArticleCollectionDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdAt"]
  }
};
